import cx from 'classnames';
import styles from './styles.module.css';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import config from '@plone/registry';

interface BowlingCenterProductsProps {
  bowlingCenterProducts: string[];
  producticons: any;
}

const BowlingCenterProducts = ({
  bowlingCenterProducts,
  producticons,
}: BowlingCenterProductsProps) => {
  const Image = config.getComponent({ name: 'Image' }).component;
  return (
    <div className={styles.bowlingcenterproductswrapper}>
      {bowlingCenterProducts?.map((product, index) => {
        const icon = producticons[product]?.icon;
        const url = producticons[product]?.url;
        const product_url = producticons[product]?.product_url;
        const image_url = `${product_url || url}/${icon}`;
        return (
          <UniversalLink
            key={product + index}
            className={cx(styles.productlogo, 'productlogo')}
            href={url}
            openLinkInNewTab={false}
          >
            <Image src={image_url} alt={product} title={product} />
          </UniversalLink>
        );
      })}
    </div>
  );
};

export default BowlingCenterProducts;
